import React, { useContext, useMemo } from 'react';
import { emptyArray, noop } from '@fabric-ui/utils';
import { SanitizeHTML } from '@utils/UtilsV2';
import { sanitize } from '../../../../utils/utils';
import AvRichText from '../../../Tickets/AvRichText';
import { CustomDashboardContext } from '../../CustomDashboardContext';
import { TextCategoryWidgetTypes } from '../../types';
import { TextSubType } from '../../types/TextWidget.types';

interface TextWidgetProps {
  widget: TextCategoryWidgetTypes;
  data?: Record<string, any>[];
  isLoading?: boolean;
  isEdit?: boolean;
}

const TextWidget: React.FC<TextWidgetProps> = ({ widget, data = emptyArray, isEdit = false }) => {
  const { setNewWidget } = useContext(CustomDashboardContext);
  const handleNewText = (text: string) => {
    if (widget.type !== TextSubType.Text) {
      return;
    }
    const sanitized = sanitize(text);
    if (sanitized === widget.definition.custom.text) {
      return;
    }
    setNewWidget({
      ...widget,
      definition: {
        ...widget.definition,
        custom: {
          ...widget.definition.custom,
          text: sanitized,
        },
      },
    });
  };

  const renderTextWidget = useMemo(
    () => ({
      [TextSubType.Text]: () => (
        <div>
          {isEdit ? (
            <AvRichText
              onClick={noop}
              onFocus={noop}
              showBar
              value={widget.definition.custom.text}
              onChange={handleNewText}
              placeholder="Add your text here..."
              // onKeyDown={onKeyDown}
              // @ts-ignore
              fileUploadProps={{ enable: false }}
            />
          ) : (
            <SanitizeHTML html={widget.definition.custom.text} openLinksInNewTab noNetworkTags />
          )}
        </div>
      ),
    }),
    [data, widget]
  );
  return renderTextWidget[widget.type]();
};

export default TextWidget;
